/**
 * Created by linjianxi on 2016/10/25.
 */
export const GET_REFLECT_LIST = 'GET_REFLECT_LIST'



// WEBPACK FOOTER //
// ./src/vuex/modules/reflect/mutation-type.js